import { render, staticRenderFns } from "./DealerStats.vue?vue&type=template&id=1a2c3c92&scoped=true&"
import script from "./DealerStats.vue?vue&type=script&lang=js&"
export * from "./DealerStats.vue?vue&type=script&lang=js&"
import style0 from "@/styles/stats.css?vue&type=style&index=0&id=1a2c3c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2c3c92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VIcon,VSelect,VSkeletonLoader})
